import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { Result } from "src/app/shared/model/response.model";
import { DataService } from "src/app/shared/services/data.service";
import {URLS} from "src/app/components/admin/look-up-tables/pages/look-up-tables/look-up-table-api-constant";

import {AddManufacturerModel, BillingTermsList, CurrencyList, DeletModel, DeleteSaleCommissionModel, GetSaleCommissionResponse, InsertUpdateManufacturer, LookupAddUpdateModel, LookupTabelModel, LookupValueModel, ManufacturerModel, NCMCodes, NCMCodesID, SaleCommissionPostModel, ScopeAddUpdateModel, ScopeModel, ShippingMethods, ShippingProvAndMethods, ShippingProvidersAndMethodsList, ShippingProvidersAndMethodsModel, TagsList, UpdateDeleteBillingTermsList, UpdateLookupValueStatus, UpdateManufacturerModel, UpdateManufacturerStatus, UpdateSaleCommissionStatus, UpdateValueStatus,  WarehouseList, VendorLeadTimeList, UpdateDeleteVendorLeadTimeList, CustomerLeadTimeList, UpdateDeleteCustomerLeadTimeList} from "./look-up-tables.model"

@Injectable({
  providedIn: 'root'
})
export class LookUpTablesService {
  
  constructor(public router: Router,public service: DataService,) { }

  GetAllLookupTable(lookupRequest: LookupTabelModel): Observable<Result> {
    let url = URLS.master.getAllLookupTable;
    return this.service.post(url, lookupRequest, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  GetAllLookupValuel(lookupRequest: LookupValueModel): Observable<Result> {
    let url =URLS.master.getAllLookupValue;
    return this.service.getWithParams(url, lookupRequest, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  
  updateLookupValueStatus(data: UpdateLookupValueStatus): Observable<Result> {
    let url = URLS.master.updateMasterTagsStatus;
    const myjson = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  updateWarehouseValueStatus(data: UpdateValueStatus): Observable<Result> {
    let url = URLS.warehouse.updateWarehouseStatus;
    const myjson = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<Result>( tap((response: any) => {
        return response;
      })
    );
  }
  updateBillingValueStatus(data: UpdateValueStatus): Observable<Result> {
    let url =  URLS.billingTerms.updateBillingTermsStatus;
    const myjson = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<Result>( tap((response: any) => {
        return response;
      })
    );
  }
  updateCurrencyValueStatus(data: UpdateValueStatus): Observable<Result> {
    let url = URLS.currency.updateCurrencyStatus;
    const myjson = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<Result>(tap((response: any) => {
        return response;
      })
    );
  }
  updateNcmCodeValueStatus(data: UpdateValueStatus): Observable<Result> {
    let url = URLS.nCMCodeManagement.updateNCMCodeStatus;
    const myjson = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<Result>(tap((response: any) => {
        return response;
      })
    );
  }
  updateSaleCommissionValueStatus(saleCommission: UpdateSaleCommissionStatus, typeid: number): Observable<Result> {
    let url = URLS.userCommission.updateUserCommissionStatus;
    saleCommission.updateStatusTypeId = typeid;
    const myjson = JSON.stringify(saleCommission);
    return this.service.post(url, saleCommission, true).pipe<Result>(tap((response: any) => {
        return response;
      })
    );
  }
  updateShippingProviderValueStatus(saleCommission: UpdateSaleCommissionStatus, typeid: number): Observable<Result> {
    let url = URLS.shippingProvider.updateShippingProviderAndMethodStatus;
    saleCommission.updateStatusTypeId = typeid;
    const myjson = JSON.stringify(saleCommission);
    return this.service.post(url, saleCommission, true).pipe<Result>(tap((response: any) => {
        return response;
      })
    );
  }

  updateManufacturerValueStatus(saleCommission: UpdateManufacturerStatus, typeid: number): Observable<Result> {
    let url = URLS.manufacturer.updateManufacturerStatus;
    saleCommission.manufacturerStatusId = typeid;
    const myjson = JSON.stringify(saleCommission);
    return this.service.post(url, saleCommission, true).pipe<Result>(tap((response: any) => {
        return response;
      })
    );
  }

  updateTagValueStatus(updateValueStatus: UpdateValueStatus): Observable<Result> {
    let url = 'app/masterTags/updateMasterTagsStatus';
    const myjson = JSON.stringify(updateValueStatus);
    return this.service.post(url, updateValueStatus, true).pipe<Result>(tap((response: any) => {
        return response;
      })
    );
  }


  //get All shipping providers
  GetAllShippingProvidersAndMethods(shippingProvidersAndMethodsModel: ShippingProvidersAndMethodsModel): Observable<Result> {
    let url = URLS.shippingProvider.getAllShippingProvidersAndMethods;
    return this.service.post(url, shippingProvidersAndMethodsModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

    //get All Warehouse providers
    GetAllWarehouse(warehouseModel: LookupValueModel): Observable<Result> {
      let url = URLS.warehouse.getAllWarehouse;
      return this.service.post(url, warehouseModel, true).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }

  //get All NCM Code 
  GetAllNcmCode(ncmCodeModel: LookupValueModel): Observable<Result> {
    let url = URLS.nCMCodeManagement.getAllNCMCodeManagement;
    return this.service.post(url, ncmCodeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getTags(tagsLookupValueModel:LookupValueModel):Observable<Result>{
    let url=URLS.master.getAllMasterTags;
    return this.service.post(url,tagsLookupValueModel).pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }

  insertTagData(tagsList:TagsList){
    let url=URLS.master.insertMasterTags;
    return this.service.post(url,tagsList).pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }

  updateTagData(tagsList:TagsList){
    let url=URLS.master.updateMasterTags;
    return this.service.post(url,tagsList).pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }


  deleteTagRecord(id){
    let url=`${URLS.master.deleteMasterTags}?id=${id}`;
    return this.service.delete(url,true).pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }
  //get All Billing Data
  GetAllBillingTerms(bilingTermsModel: LookupValueModel): Observable<Result> {
    let url = URLS.billingTerms.getAllBillingTermsManagement;
    return this.service.post(url, bilingTermsModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  // get all currency Data 
  GetAllCurrency(currencyModel:LookupValueModel ): Observable<Result> {
    let url = URLS.currency.getAllCurrency;
    return this.service.post(url, currencyModel).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }
    // get all saleCommission 
    GetAllSaleCommission (saleCommission :SaleCommissionPostModel , typeid: number): Observable<Result> 
    {
      let url = URLS.userCommission.getAllUserCommission;
      saleCommission.typeId = typeid;
      return this.service.post(url, saleCommission , true).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }

  addAndUpdateLookupValue(lookupAddUpdate: LookupAddUpdateModel): Observable<Result> {
    let url = URLS.master.insertUpdateLookupValue;
    const myjson = JSON.stringify(lookupAddUpdate);
    return this.service.post(url, lookupAddUpdate, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
 
  deleteLookupValue(DeletedId): Observable<Result> {
    let url = `${URLS.master.deleteLookupValue}?id=${DeletedId}`;
    const myjson = JSON.stringify({Id:DeletedId});
    return this.service.delete(url,true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  insertWarehouse(warehouseModel:WarehouseList): Observable<Result> {
    let url = URLS.warehouse.insertWarehouse;
    return this.service.post(url, warehouseModel, true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  updateWarehouse(warehouseModel:WarehouseList): Observable<Result> {
    let url = URLS.warehouse.updateWarehouse;
    const myjson = JSON.stringify(warehouseModel);
    return this.service.post(url, warehouseModel, true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  deleteWarehouse(deleteWarehouseModel:any): Observable<Result> {
    let url = `${URLS.warehouse.deleteWarehouse}?id=${deleteWarehouseModel}`;
    const myjson = JSON.stringify(deleteWarehouseModel);
    return this.service.delete(url,true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  GetScopeValuel(lookupRequest: ScopeModel): Observable<Result> {
    let url = URLS.scope.getAllScopes;
    return this.service.post(url, lookupRequest, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  addAndUpdateScopeValue(scopeModel: ScopeAddUpdateModel): Observable<Result> {
    let url = URLS.scope.insertUpdateScope;
    const myjson = JSON.stringify(scopeModel);
    return this.service.post(url, scopeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  insertShipping(shippingProvidersAndMethodsList:ShippingProvidersAndMethodsList): Observable<Result> {
    let url = URLS.shippingProvider.insertShippingProviders;
    const myjson = JSON.stringify(shippingProvidersAndMethodsList);
    return this.service.post(url, shippingProvidersAndMethodsList, true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }


  updateShipping(shippingProvidersAndMethodsList:ShippingProvidersAndMethodsList): Observable<Result> {
    let url = URLS.shippingProvider.updateShippingProviders;
    const myjson = JSON.stringify(shippingProvidersAndMethodsList);
    return this.service.post(url, shippingProvidersAndMethodsList, true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  deleteShipping(deleteShippingProviders:any): Observable<Result> {
    let url = "delete shipping provider pending";
    const myjson = JSON.stringify(deleteShippingProviders);
    return this.service.post(url, deleteShippingProviders, true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }
  deleteShippingProvAndMethods(deleteShippingProviders:ShippingProvAndMethods,typeId:number): Observable<Result> {
    let url = URLS.shippingProvider.deleteShippingProviderOrMethod;
    deleteShippingProviders.deleteTypeId = typeId;
    const myjson = JSON.stringify(deleteShippingProviders);
    return this.service.post(url, deleteShippingProviders, true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  AddBilling(insertEditDeleteBillingModel:BillingTermsList): Observable<Result> {
    let url = URLS.billingTerms.insertBillingTerms;
    const myjson = JSON.stringify(insertEditDeleteBillingModel);
    return this.service.post(url, insertEditDeleteBillingModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  UpdateDeleteBilling(editDeleteBillingModel:UpdateDeleteBillingTermsList): Observable<Result> {
    let url = URLS.billingTerms.updateBillingTerms;
    const myjson = JSON.stringify(editDeleteBillingModel);
    return this.service.post(url, editDeleteBillingModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  deleteBillingRecord(id){
    let url=`${URLS.billingTerms.deleteBillingTerms}?id=${id}`;
    return this.service.delete(url).pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }


  AddEditDeleteNcmCode(insertEditDeleteNcmCodeModel:NCMCodes): Observable<Result> {
    let url = URLS.nCMCodeManagement.insertNCMCodeManagementInfo;
    const myjson = JSON.stringify(insertEditDeleteNcmCodeModel);
    return this.service.post(url, insertEditDeleteNcmCodeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  AddEditNcmCode(insertEditDeleteNcmCodeModel:NCMCodes): Observable<Result> {
    let url = URLS.nCMCodeManagement.updateNCMCodeManagementInfo;
    const myjson = JSON.stringify(insertEditDeleteNcmCodeModel);
    return this.service.post(url, insertEditDeleteNcmCodeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  DeleteNcmCode(insertEditDeleteNcmCodeModel:any): Observable<Result> {
    let url = `${URLS.nCMCodeManagement.deleteNCMCodeManagement}?id=${insertEditDeleteNcmCodeModel}`;
    const myjson = JSON.stringify(insertEditDeleteNcmCodeModel);
    return this.service.delete(url,true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  insertCurrency(insertEditDeleteCurrencyModel:CurrencyList): Observable<Result> {
    let url = URLS.currency.insertCurrencyInfo;
    const myjson = JSON.stringify(insertEditDeleteCurrencyModel);
    return this.service.post(url, insertEditDeleteCurrencyModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  updateCurrency(insertEditDeleteCurrencyModel:CurrencyList): Observable<Result> {
    let url = URLS.currency.updateCurrencyInfo;
    const myjson = JSON.stringify(insertEditDeleteCurrencyModel);
    return this.service.post(url, insertEditDeleteCurrencyModel, true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  deleteCurrency(id:any): Observable<Result> {
    let url = `${URLS.currency.deleteCurrencyInfo}?id=${id}`;
    return this.service.delete(url,true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  // Insert Upadte saleComission
  InsertSaleCommission(getSaleCommissionResponse:GetSaleCommissionResponse, typeid: number):Observable<Result>
  {
    let url = URLS.userCommission.insertCommission;
    getSaleCommissionResponse.typeId = typeid;
    return this.service.post(url, getSaleCommissionResponse, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  UpdateSaleCommission(getSaleCommissionResponse:GetSaleCommissionResponse, typeid: number):Observable<Result>
  {
    let url = URLS.userCommission.updateCommission
    getSaleCommissionResponse.typeId = typeid;
    return this.service.post(url, getSaleCommissionResponse, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

    // Delete sale commission App/UserCommission/deleteUserCommission
    DeleteSAleCommissiom(deletModel:any):Observable<Result>{
      let url = `${URLS.userCommission.deleteUserCommission}?id=${deletModel}`
      return this.service.delete(url,true).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }
    
    // purcahese
DeletePurchasecommission(deletModel:any,typeId:number ):Observable<Result>{
  let url =`${URLS.userCommission.deleteUserCommission}?id=${deletModel}`;
  return this.service.delete(url,true).pipe<Result>(tap((response: any) => {
  return response;
    })
  );
}
// purchase mapping delete
DeleteMapping(deletModel:any):Observable<Result>{
    let url =`${URLS.userCommission.deleteUserCommissionRange}?id=${deletModel}`;
    return this.service.delete(url,true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
}

// get all Manufacturer
GetAllManufacturer (manufacturerpost :SaleCommissionPostModel ): Observable<Result> 
{
  let url = URLS.manufacturer.getAllManufacturers;
  return this.service.post(url, manufacturerpost , true).pipe<Result>(
    tap((response: any) => {
      return response;
    })
  );
}

// Delet Manufacturer
DeletManufacturer(deletModel:DeletModel):Observable<Result>{
  let url =`${URLS.manufacturer.deleteManufacturer}?id=${deletModel}`;
  return this.service.delete(url,true).pipe<Result>(
    tap((response: any) => {
      return response;
    })
  );
}
DeletManufacturerMapping(deletModel:DeletModel):Observable<Result>{
  let url =`${URLS.manufacturer.deleteChildManufacturer}?id=${deletModel}`;
  return this.service.delete(url,true).pipe<Result>(
    tap((response: any) => {
      return response;
    })
  );
}

getManufacturerList():Observable<Result>{
  let url=URLS.dropdown.getAllManufacturerDropdown;
  return this.service.get(url,true).pipe<Result>(tap((response:any)=>{
  return response
 }))
}

addManufacturer(data:AddManufacturerModel):Observable<Result>{
  let  url =URLS.manufacturer.addManufacturer;
  return this.service.post(url, data, true).pipe<Result>(
    tap((response: any) => {
      return response;
    })
  );
}
addRelatedEntityManufacturer(data:any):Observable<Result>{
  let  url =URLS.manufacturer.addRelatedEntityManufacturer;
  return this.service.post(url, data, true).pipe<Result>(
    tap((response: any) => {
      return response;
    })
  );
}

updateManufacturer(data:UpdateManufacturerModel):Observable<Result>{
  let url =URLS.manufacturer.updateManufacturer;
  return this.service.post(url, data, true).pipe<Result>(
    tap((response: any) => {
      return response;
    })
  );
}
updateManufacturerUnlinkStatus(data:any):Observable<Result>{
  let url ="app/manufacturer/updateManufacturerUnlinkStatus";
  return this.service.post(url, data, true).pipe<Result>(
    tap((response: any) => {
      return response;
    })
  );
}
addPrimaryManufacturer(data:any):Observable<Result>{
  let url ="app/manufacturer/addNewPrimaryManufacturer";
  return this.service.post(url, data, true).pipe<Result>(
    tap((response: any) => {
      return response;
    })
  );
}

  // VendorLeadTime Methods
  GetAllVendorLeadTime(vendorLeadTimeModel: LookupValueModel): Observable<Result> {
    let url = URLS.vendorLeadTime.getAllVendorLeadTime;
    return this.service.post(url, vendorLeadTimeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  AddVendorLeadTime(insertEditDeleteVendorLeadTimeModel: VendorLeadTimeList): Observable<Result> {
    let url = URLS.vendorLeadTime.insertVendorLeadTime;
    const myjson = JSON.stringify(insertEditDeleteVendorLeadTimeModel);
    return this.service.post(url, insertEditDeleteVendorLeadTimeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  UpdateDeleteVendorLeadTime(editDeleteVendorLeadTimeModel: UpdateDeleteVendorLeadTimeList): Observable<Result> {
    let url = URLS.vendorLeadTime.updateVendorLeadTime;
    const myjson = JSON.stringify(editDeleteVendorLeadTimeModel);
    return this.service.post(url, editDeleteVendorLeadTimeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  deleteVendorLeadTime(id: any): Observable<Result> {
    let url = `${URLS.vendorLeadTime.deleteVendorLeadTime}?id=${id}`;
    return this.service.delete(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  updateVendorLeadTimeStatus(data: UpdateValueStatus): Observable<Result> {
    let url = URLS.vendorLeadTime.updateVendorLeadTimeStatus;
    const myjson = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  // CustomerLeadTime Methods
  GetAllCustomerLeadTime(customerLeadTimeModel: LookupValueModel): Observable<Result> {
    let url = URLS.customerLeadTime.getAllCustomerLeadTime;
    return this.service.post(url, customerLeadTimeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  AddCustomerLeadTime(insertEditDeleteCustomerLeadTimeModel: CustomerLeadTimeList): Observable<Result> {
    let url = URLS.customerLeadTime.insertCustomerLeadTime;
    const myjson = JSON.stringify(insertEditDeleteCustomerLeadTimeModel);
    return this.service.post(url, insertEditDeleteCustomerLeadTimeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  UpdateDeleteCustomerLeadTime(editDeleteCustomerLeadTimeModel: UpdateDeleteCustomerLeadTimeList): Observable<Result> {
    let url = URLS.customerLeadTime.updateCustomerLeadTime;
    const myjson = JSON.stringify(editDeleteCustomerLeadTimeModel);
    return this.service.post(url, editDeleteCustomerLeadTimeModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  deleteCustomerLeadTime(id: any): Observable<Result> {
    let url = `${URLS.customerLeadTime.deleteCustomerLeadTime}?id=${id}`;
    return this.service.delete(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  updateCustomerLeadTimeStatus(data: UpdateValueStatus): Observable<Result> {
    let url = URLS.customerLeadTime.updateCustomerLeadTimeStatus;
    const myjson = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
}
